import { jsx as _jsx } from "react/jsx-runtime";
{
    /* <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> */
}
const PencilIcon = (props) => {
    return (_jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", strokeWidth: 0.25, stroke: "currentColor" }, props, { children: _jsx("path", { d: "M17.7354 0L0 17.7393V23.7431L6.22931 24L24 6.2405L17.7354 0ZM5.42797 21.9501L2.01596 21.809V18.5704L2.61571 17.9962L6.0126 21.391L5.42797 21.9501ZM7.41369 19.9656L4.0168 16.591L15.2608 5.33389L18.6577 8.72865L7.41369 19.9656ZM16.6871 3.9085L17.7354 2.84575L21.1323 6.2405L20.0689 7.30325L16.6871 3.9085Z", fill: "currentColor" }) })));
};
export default PencilIcon;
